<template>
  <div v-if="params.revenue_cost != null">
    <div v-if="params.revenue_cost === -1">
      <span>{{ $t("myLoads.myLoadsTable.invoicePending") }}</span>
    </div>
    <div
      v-else-if="setLoadStatusColor(params.load_status).label === 'Delivered'"
    >
      <span v-if="showCost">{{ params.revenue_cost | priceToUsd }}</span>
    </div>
    <div v-else>
      <span>{{ params.revenue_cost | priceToUsd }}</span>
    </div>
  </div>
</template>
<script>
import LoadStatusType from "../../Extend/LoadStatusType";

export default {
  name: "LoadRevenueCost",
  props: {
    params: {
      type: Object,
    },
  },
  data() {
    return {
      showCost: false,
    };
  },
  mixins: [LoadStatusType],
  created() {
    this.showCost = this.$store.getters["login/getTokenInfo"].show_cost;
  },
};
</script>
